// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import logo from "../assets/logo.png";

const PJS = { fontFamily:"'Plus Jakarta Sans',sans-serif" };
const DS  = { fontFamily:"'DM Sans',sans-serif" };

export default function Footer() {
  const yr = new Date().getFullYear();
  const ci = new Date(Date.now()+45*86400000).toISOString().split("T")[0];
  const co = new Date(Date.now()+52*86400000).toISOString().split("T")[0];

  const dests = ["Dubai","Antalya","Tenerife","Maldives","Majorca","Lanzarote","Phuket","Barcelona","Paris","Rome"];
  const types = [
    {l:"All-Inclusive Holidays", p:"/packages"},
    {l:"Beach Holidays",         p:"/packages"},
    {l:"City Breaks",            p:"/packages"},
    {l:"Luxury Holidays",        p:"/packages"},
    {l:"Family Holidays",        p:"/packages"},
    {l:"Honeymoon",              p:"/packages"},
    {l:"Hotels",                 p:"/hotels"},
  ];

  const PhoneIco = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  );
  const MailIco = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  );
  const PinIco = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  );
  const WAIco = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/>
    </svg>
  );

  const ContactRow = ({ icon:Icon, text, href, external }) => (
    <div style={{ display:"flex", alignItems:"flex-start", gap:9, fontSize:13, color:"#94a3b8", marginBottom:7, ...DS }}>
      <span style={{ color:"#60a5fa", flexShrink:0, marginTop:1 }}><Icon/></span>
      {href
        ? <a href={href} target={external?"_blank":undefined} rel={external?"noreferrer":undefined}
            style={{ color:"#94a3b8", textDecoration:"none", lineHeight:1.5 }}
            onMouseEnter={e=>e.target.style.color="#fff"}
            onMouseLeave={e=>e.target.style.color="#94a3b8"}>{text}</a>
        : <span style={{ lineHeight:1.5 }}>{text}</span>
      }
    </div>
  );

  return (
    <>
      {/* ── CTA Banner ── */}
      <section style={{ background:"linear-gradient(135deg,#0b3d91 0%,#1a56db 100%)", padding:"54px 20px", textAlign:"center" }}>
        <div style={{ maxWidth:680, margin:"0 auto" }}>
          <h2 style={{ fontSize:"clamp(22px,3.5vw,32px)", fontWeight:900, color:"#fff", margin:"0 0 12px", ...PJS }}>
            Ready to book your perfect holiday?
          </h2>
          <p style={{ color:"rgba(255,255,255,.82)", fontSize:15.5, marginBottom:28, lineHeight:1.6, ...DS }}>
            Talk to our experts for the best prices and a tailored holiday — 7 days a week.
          </p>
          <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap", marginBottom:22 }}>
            <a href="tel:02030190055"
              style={{ display:"inline-flex", alignItems:"center", gap:8, padding:"13px 28px", background:"#fff", color:"#0b3d91", borderRadius:999, fontSize:16, fontWeight:800, textDecoration:"none", ...PJS, transition:"transform .2s, box-shadow .2s" }}
              onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.04)";e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,.22)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}>
              <PhoneIco/> 020 3019 0055
            </a>
            <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer"
              style={{ display:"inline-flex", alignItems:"center", gap:8, padding:"13px 28px", background:"#25d366", color:"#fff", borderRadius:999, fontSize:16, fontWeight:800, textDecoration:"none", ...PJS, transition:"transform .2s, box-shadow .2s" }}
              onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.04)";e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,.22)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}>
              <WAIco/> WhatsApp
            </a>
          </div>
          <div style={{ display:"flex", gap:20, justifyContent:"center", flexWrap:"wrap", color:"rgba(255,255,255,.88)", fontSize:13.5, fontWeight:600, ...DS }}>
            {["Expert Advice","Best Prices","No Hidden Fees","Secure Booking"].map(t => (
              <span key={t} style={{ display:"flex", alignItems:"center", gap:5 }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                {t}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ── Main footer ── */}
      <footer style={{ background:"#0f172a", color:"#94a3b8" }}>
        <div style={{ maxWidth:1280, margin:"0 auto", padding:"48px 24px 32px", display:"grid", gridTemplateColumns:"2fr 1fr 1fr 1.4fr", gap:36 }} className="ft-grid">

          {/* Brand column */}
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}>
              <div style={{ width:44, height:44, borderRadius:"50%", background:"#fff", border:"2.5px solid #1565c0", display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", flexShrink:0 }}>
                <img src={logo} alt="Broadway Holidays" style={{ width:36, height:36, objectFit:"contain" }}/>
              </div>
              <div>
                <div style={{ fontSize:16, fontWeight:900, color:"#fff", ...PJS }}>Broadway</div>
                <div style={{ fontSize:12, fontWeight:600, color:"#60a5fa", ...PJS }}>Holidays</div>
              </div>
            </div>
            <p style={{ fontSize:13.5, color:"#94a3b8", lineHeight:1.65, marginBottom:16, ...DS }}>
             Beach Travels (Trading as Broadway Holidays) is your trusted UK travel partner. Expert advice, best prices, no hidden fees.
            </p>

            <div style={{ marginBottom:16 }}>
              <div style={{ fontSize:11, fontWeight:800, color:"#60a5fa", textTransform:"uppercase", letterSpacing:".07em", marginBottom:8, ...DS }}>🇬🇧 UK Office</div>
              <ContactRow icon={PhoneIco} text="020 3019 0055"                  href="tel:02030190055"/>
              <ContactRow icon={MailIco}  text="support@broadwayholidays.co.uk" href="mailto:support@broadwayholidays.co.uk"/>
              <ContactRow icon={PinIco}   text="Brayford Square, E1 0SG, London" href={null}/>
            </div>

            <div style={{ marginBottom:16 }}>
              <div style={{ fontSize:11, fontWeight:800, color:"#f97316", textTransform:"uppercase", letterSpacing:".07em", marginBottom:8, ...DS }}>🇺🇸 US Office</div>
              <ContactRow icon={PinIco} text="30 N Gould St, STE R, Sheridan, WY 82801, USA" href={null}/>
            </div>

            <div style={{ display:"flex", gap:8 }}>
              {[
                [FaFacebookF, "https://www.facebook.com/profile.php?id=61586508645183"],
                [FaInstagram, "https://www.instagram.com/broadwayholidays.co.uk/"],
                [FaTiktok,    "#!"],
                [FaYoutube,   "#!"],
              ].map(([Icon,href],i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer"
                  style={{ width:34, height:34, background:"rgba(255,255,255,.08)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", color:"#94a3b8", fontSize:14, textDecoration:"none", transition:"background .18s, color .18s" }}
                  onMouseEnter={e=>{ e.currentTarget.style.background="#1565c0"; e.currentTarget.style.color="#fff"; }}
                  onMouseLeave={e=>{ e.currentTarget.style.background="rgba(255,255,255,.08)"; e.currentTarget.style.color="#94a3b8"; }}>
                  <Icon/>
                </a>
              ))}
            </div>
          </div>

          {/* ── Company links — Refund Policy added ── */}
          <div>
            <h4 style={{ fontSize:11, fontWeight:800, color:"#fff", margin:"0 0 14px", textTransform:"uppercase", letterSpacing:".08em", ...PJS }}>Company</h4>
            <ul style={{ listStyle:"none", padding:0, margin:0 }}>
              {[
                {l:"Home",                p:"/"},
                {l:"About Us",            p:"/about"},
                {l:"Contact",             p:"/contact"},
                {l:"Hotels",              p:"/hotels"},
                {l:"Privacy Policy",      p:"/privacy"},
                {l:"Terms & Conditions",  p:"/terms"},
                {l:"Refund Policy",       p:"/refund-policy"},
              ].map(item => (
                <li key={item.p} style={{ marginBottom:9 }}>
                  <Link to={item.p} style={{ color:"#94a3b8", textDecoration:"none", fontSize:13.5, ...DS, transition:"color .15s" }}
                    onMouseEnter={e=>e.target.style.color="#fff"}
                    onMouseLeave={e=>e.target.style.color="#94a3b8"}>
                    {item.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h4 style={{ fontSize:11, fontWeight:800, color:"#fff", margin:"0 0 14px", textTransform:"uppercase", letterSpacing:".08em", ...PJS }}>Destinations</h4>
            <ul style={{ listStyle:"none", padding:0, margin:0 }}>
              {dests.map(d => (
                <li key={d} style={{ marginBottom:9 }}>
                  <Link to={`/hotels?city=${encodeURIComponent(d)}&checkIn=${ci}&checkOut=${co}&guests=2`}
                    style={{ color:"#94a3b8", textDecoration:"none", fontSize:13.5, ...DS, transition:"color .15s" }}
                    onMouseEnter={e=>e.target.style.color="#fff"}
                    onMouseLeave={e=>e.target.style.color="#94a3b8"}>
                    {d}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Holiday types */}
          <div>
            <h4 style={{ fontSize:11, fontWeight:800, color:"#fff", margin:"0 0 14px", textTransform:"uppercase", letterSpacing:".08em", ...PJS }}>Stay Types</h4>
            <ul style={{ listStyle:"none", padding:0, margin:0, marginBottom:20 }}>
              {types.map(item => (
                <li key={item.l} style={{ marginBottom:9 }}>
                  <Link to={item.p} style={{ color:"#94a3b8", textDecoration:"none", fontSize:13.5, ...DS, transition:"color .15s" }}
                    onMouseEnter={e=>e.target.style.color="#fff"}
                    onMouseLeave={e=>e.target.style.color="#94a3b8"}>
                    {item.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop:"1px solid rgba(255,255,255,.07)", padding:"18px 24px 90px", maxWidth:1280, margin:"0 auto" }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:10 }}>
            <p style={{ fontSize:13, color:"#475569", margin:0, ...DS }}>
              © {yr} Broadway Holidays. All rights reserved. Registered in England &amp; Wales.
            </p>
            <p style={{ fontSize:12, color:"#334155", margin:0, ...DS }}>
              Prices include our service fee and are subject to availability.
            </p>
          </div>
        </div>
      </footer>

      <style>{`
        @media(max-width:1100px){ .ft-grid{ grid-template-columns:1fr 1fr !important; } }
        @media(max-width:900px) { .ft-grid{ grid-template-columns:1fr 1fr !important; } }
        @media(max-width:520px) {
          .ft-grid{ grid-template-columns:1fr !important; }
          .ft-branches{ flex-direction:column !important; gap:0 !important; }
        }
      `}</style>
    </>
  );
}